import { connect } from 'react-redux'

import { NoticeCheckout } from 'components/Notice'
import { getNotice } from 'redux/modules/notice'

export default connect(({ notice }, ownProps) => ({
  item: getNotice({ type: 'checkout', page: ownProps.type, notice })
}))(NoticeCheckout)
